import { Component, Input } from '@angular/core';

@Component({
  selector: 'bc-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() height;

  @Input() borderWidth = 2;
  @Input() dimensions = 25;
}
